<app-single-detail
  svgIcon="feather:clipboard"
  label="Code"
  [value]="siteLocationDetails?.code"
></app-single-detail>
<app-single-detail
  svgIcon="feather:file-text"
  label="Description"
  [value]="memoizedGetValueOrDash(siteLocationDetails?.description)"
></app-single-detail>
<app-single-detail
  svgIcon="feather:map-pin"
  label="Site"
  [value]="siteLocationDetails?.siteName"
></app-single-detail>
<app-single-detail
  svgIcon="feather:hexagon"
  label="Status"
  [value]="siteLocationDetails?.capacityStatus"
></app-single-detail>
